import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Select, Tag } from 'udesk-ui';
import { SelectProps } from 'antd';
import { getProductDetailsFindNoMainProduct } from 'src/api/productDetails/findNoMainProduct';
import UdeskLocales from 'UdeskLocales';

export interface TemplateProps extends SelectProps<number[]> {}

const Template: FC<TemplateProps> = memo((props) => {
    const { onDropdownVisibleChange, ...restProps } = props;

    const [options, setOptions] = useState<any[]>([]);

    const { refresh } = useRequest(getProductDetailsFindNoMainProduct, {
        onSuccess: (res) => {
            setOptions(res.data?.map((d) => ({ value: d.id, label: d.title })) || []);
        },
    });

    const _onDropdownVisibleChange = (open: boolean) => {
        if (open) {
            refresh();
        }

        onDropdownVisibleChange?.(open);
    };

    return (
        <Select
            {...restProps}
            placeholder={/* 请选择产品数据 */UdeskLocales['current'].pages.conversationAnalysis.productManage.components.subProduct.components.unrelatedProducts.index.pleaseSelectProductData}
            style={{ width: 500, textAlign: 'left' }}
            options={options}
            mode="multiple"
            maxTagCount={3}
            value={props.value}
            onChange={props.onChange}
            onDropdownVisibleChange={_onDropdownVisibleChange}
            filterOption={(input, option) =>
                ((option?.label ?? '') as string).toLowerCase().includes(input.toLowerCase())
            }
            tagRender={(props) => {
                const { label, closable, onClose } = props;
                const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
                    event.preventDefault();
                    event.stopPropagation();
                };

                return (
                    <Tag
                        onMouseDown={onPreventMouseDown}
                        closable={closable}
                        onClose={onClose}
                        title={label as string}
                        style={{
                            maxWidth: 120,
                            display: 'inline-flex',
                            alignItems: 'center',
                        }}
                    >
                        <span
                            style={{
                                width: '100%',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {label}
                        </span>
                    </Tag>
                );
            }}
        />
    );
});

export default Template;
